














import { Component, Mixins, Ref } from 'vue-property-decorator'
import InputWithLabel from '@/components/common/atoms/InputWithLabel.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import QrCodeReader from '@/components/common/atoms/QrCodeReader.vue'
import LoginMethods from '@/mixins/LoginMethods.vue'
import { QR_LOGIN_PARAM_SEPARATOR } from '@/constants/ApiConstant'

@Component({
  components: {
    InputWithLabel,
    ButtonBase,
    QrCodeReader,
  },
})
export default class QrLogin extends Mixins(LoginMethods) {
  /** QRコード読み込みコンポーネント */
  @Ref() qrCodeReaderRef!: QrCodeReader

  /**
   * 二次元コードが読み取れない場合（通常ログイン画面に遷移）
   */
  private async clickDefaultLoginButton(): Promise<void> {
    this.$router.push({ name: 'StudentLogin' })
  }

  /**
   * QRコード読み込み成功時処理
   */
  private async readQrCode(qrCodeData: string): Promise<void> {
    const qrCodeParams = qrCodeData.split(QR_LOGIN_PARAM_SEPARATOR, 2)
    const isLoginSuccess = await this.studentQrLogin(qrCodeParams[0], qrCodeParams[1])
    // ログイン失敗時、一呼吸置いてQRコード読み込みカメラ再起動
    if (!isLoginSuccess) setTimeout(() => this.qrCodeReaderRef.startMediaDevice(), 2000)
  }
}
